var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "backup-codes-modal" },
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "confirmationDialog",
        {
          attrs: {
            dialogStatus: _vm.dialogStatus,
            title: "2FA Backup Codes",
            eventName: "backupCodes"
          },
          on: { backupCodes: _vm.backupCodesActions }
        },
        [
          _c(
            "v-container",
            { class: _vm.fromHeader ? "pa-0" : "pa-3" },
            [
              _c(
                "v-layout",
                { staticClass: "codes", attrs: { wrap: "", row: "" } },
                [
                  _c(
                    "v-list",
                    _vm._l(_vm.backupCodes, function(code) {
                      return _c(
                        "v-list-tile",
                        { key: code },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "grey" } }, [
                                _vm._v("fiber_manual_record")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", {
                                staticClass: "backupCodes",
                                domProps: { textContent: _vm._s(code) }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "actions pt-3 ma-0", attrs: { wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs6: "" } }, [
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.download()
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("get_app")]), _vm._v("Download")],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs6: "" } }, [
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.copy()
                          }
                        }
                      },
                      [
                        _c("v-icon", [
                          _vm._v(
                            _vm._s(_vm.copiedContent ? "done" : "content_copy")
                          )
                        ]),
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.copiedContent
                                ? "Copied!"
                                : "Copy to clipboard"
                            ) +
                            "\n                    "
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  staticClass: "text_element font-weight-medium",
                  attrs: { wrap: "" }
                },
                [
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("br"),
                    _vm._v(
                      "\n                    Write down these emergency backup codes and store it somewhere safe. If you lose your mobile device,you can use this code to bypass two-step authentication.\n                "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.fromHeader
                    ? _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("br"),
                        _vm._v(
                          "\n                    From now on, whenever you sign in to your account, you'll need to enter both your password and also an authentication code generated by Google Authenticator.\n                "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }